import { Button } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';
import { device } from 'utils/device';

const Container = styled.section`
    display: flex;
    flex: 1;
    align-items: center;
    padding: ${rem(8)} ${rem(8)} ${rem(8)} ${rem(24)};

    @media ${device.maxTablet} {
        padding: 0 ${rem(8)};
    }
`;

const DatesContainer = styled.div`
    display: flex;
    flex: 1;

    @media ${device.maxTablet} {
        justify-content: center;
    }
`;

const DateContainer = styled.div<{ $highlight: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
    color: ${({ $highlight, theme }) => ($highlight ? theme.vui.colors.neutral.gray80 : theme.vui.colors.neutral.gray40)};
`;

const Day = styled.p`
    line-height: 1.2;
`;

const DayAndMonth = styled.p`
    font-weight: 700;
`;

const NavigationButton = styled(Button)<{ $hidden?: boolean }>`
    padding: 0;
    min-width: ${rem(24)};
    width: ${rem(40)};
    height: ${rem(40)};
    border: none !important;
    visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
    color: ${({ theme }) => theme.vui.colors.primary};
    transition: none;
    &:disabled {
        background: none !important;
    }
`;

export { Container, DatesContainer, DateContainer, Day, DayAndMonth, NavigationButton };
